import React from 'react';
import Icons from '../../../../../../../../components/Common/Icons/Icons';
import ModalDelete from '../../../../../../Common/Modals/Delete';

const DeleteModuleData = [
  { key: 'Module:', value: 2 },
  { key: 'Tab:', value: 'A' },
];

function ModalDeleteModule() {
  return (
    <ModalDelete
      title="Delete Tab"
      trigger={
        <Icons.CloseIcon
          className="cursor-pointer [&_path]:fill-primary [&_path]:opacity-50
              hidden group-hover:block"
        />
      }
      okText="Delete Tab"
      contentStyle="max-w-[600px]"
      triggerStyle="absolute top-[5px] right-[5px]"
      content={
        <>
          <div>
            {DeleteModuleData.map(({ key, value }) => (
              <div className="grid grid-cols-[60px_1fr] gap-[10px]" key={key}>
                <div className="font-medium">{key}</div>
                <div className="opacity-60">{value}</div>
              </div>
            ))}
          </div>
          <div className="opacity-80">Some text info. Some text info. Some text info. Some text info.</div>
        </>
      }
    />
  );
}

export default ModalDeleteModule;
